import { Injectable } from '@angular/core';
import { ApiConversionHelper } from '../../helpers/api-conversion.helper';
import { FirstOrganizationModel, Organization } from '../../types/organization.type';
import { BaseApiService } from './base-api.service';
import { ActionResult } from '../../types/action-result.type';
import { OnPremSynchronizationModel } from '../../types/generated.types';

@Injectable({ providedIn: 'root' })
export class OrganizationsApiService extends BaseApiService {
  protected get baseUrl(): string {
    return `${super.baseUrl}/organizations`;
  }

  // ORGANIZATION
  async getOrganizations(): Promise<Organization[]> {
    const result = await this.get<Organization[]>('');
    result.forEach(o => ApiConversionHelper.convertTimeSpans(o.configuration, ['businessHoursFrom', 'businessHoursTo']));
    return result;
  }

  async getOnPremSynchronization(organizationName: string): Promise<OnPremSynchronizationModel> {
    const result = await this.get<OnPremSynchronizationModel>(`${organizationName}/on-prem-synchronization`);
    ApiConversionHelper.convertDates(result, ['lastSynchronizationTime', 'lastSynchronizationFailTime']);
    ApiConversionHelper.convertDates(result.versions, ['fromUtc', 'toUtc']);
    return result;
  }

  async createFirstOrganization(firstOrganization: FirstOrganizationModel): Promise<void> {
    await this.post('first', firstOrganization);
  }

  async createOrganization(organization: Organization): Promise<void> {
    const organizationCopy = structuredClone(organization);
    ApiConversionHelper.convertTimeSpansForApi(organizationCopy.configuration, ['businessHoursFrom', 'businessHoursTo']);
    await this.post('', organizationCopy);
  }

  async updateOrganization(organization: Organization): Promise<void> {
    const organizationCopy = structuredClone(organization);
    ApiConversionHelper.convertTimeSpansForApi(organizationCopy.configuration, ['businessHoursFrom', 'businessHoursTo']);
    await this.put('', organizationCopy);
  }

  async generateOrganizationMonitoringDemoData(organizationName: string): Promise<ActionResult> {
    return await this.postWithResult(`${organizationName}/actions/generate-monitoring-data`, null, null, true);
  }

  async deleteAllOrganizationData(organizationName: string, retypeOrganizationName: string): Promise<ActionResult> {
    return await this.postWithResult(`${organizationName}/actions/delete-all-data?key=${retypeOrganizationName}`, null);
  }
}
